<div class="section-title-container">
  <div class="content">
    <div class="content__title" [ngClass]="{'long-title': longTitle}" >{{ title | translate }}</div>
    <div class="divider"></div>
  </div>
  <div class="content__desc">{{ desc | translate }}</div>
</div>
